import React from 'react';

import { useTheme } from '@chakra-ui/react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const ResultScaleRating = ({ data, selectedId }) => {
  const { colors } = useTheme();
  return (
    <Scale colors={colors}>
      {data.map(({ id, score }) => (
        <ScaleTile active={id === selectedId}>
          <TextBodyMedium
            sx={{
              lineHeight: 'initial',
              transform: id === selectedId && 'scaleY(0.75)',
              fontWeight: id === selectedId && 'bold',
              color: id === selectedId ? colors.button.green.focus : colors.secondary['666666'],
            }}
          >
            {score}
          </TextBodyMedium>
        </ScaleTile>
      ))}
    </Scale>
  );
};

const Scale = styled.div`
  ${({ colors }) => css`
    border: 1px solid ${colors.border.CFD7DF};
  `};
  border-radius: 4px;
  margin-top: 0.5rem;
  display: flex;
  pointer-events: none;
  width: fit-content;
`;

const ScaleTile = styled.span`
  ${(props) =>
    props.active &&
    css`
      background: ${props.theme.colors.feedback['91CA7D']};
      border-right: none !important;
      border-radius: 4px;
      transform: scaleX(1.1) scaleY(1.5);

      font-weight: bold !important;
      position: relative;
    `};
  padding: 4px 12px;
  ${(props) => css`
    border-right: 1px solid ${props.theme.colors.border.CFD7DF};
  `};
  &:last-child {
    border-right: none;
  }
  text-align: center;
  width: 32px;
  height: 22px;
  display: flex;
  align-items: center;
`;
